import { CafeApplications } from '@cookspace-shared-contracts/core';
import { z } from 'zod';

/**
 * Схемы для admin-эндпоинтов /cafe-applications/* (фича
 * cafe-company-verification, MF-5). В отличие от professional-applications,
 * контракты заявок кафе живут в shared-contracts (namespace `CafeApplications`),
 * поэтому здесь мы их реэкспортируем и собираем response-обёртки для строгого
 * парсинга ответов admin-backend через safeParse.
 *
 * ⚠️ Версия пакета `@cookspace-shared-contracts/core` с namespace
 * `CafeApplications` — 12.0.0 (на момент написания НЕ опубликована, в admin
 * установлена 6.2.1). До публикации и `npm update` импорт `CafeApplications`
 * не резолвится — typecheck/build по этому файлу не пройдёт (ожидаемо).
 */

export const CafeApplicationListItemSchema = CafeApplications.CafeApplicationListItemSchema;
export type CafeApplicationListItem = CafeApplications.CafeApplicationListItem;

export const CafeApplicationCompanySchema = CafeApplications.CafeApplicationCompanySchema;
export type CafeApplicationCompany = CafeApplications.CafeApplicationCompany;

export const CafeApplicationDetailSchema = CafeApplications.CafeApplicationDetailSchema;
export type CafeApplicationDetail = CafeApplications.CafeApplicationDetail;

/**
 * Ответ списка `GET /cafe-applications` — `{ items, total }` (как в контракте
 * `CafeApplicationsListResponseSchema`).
 */
export const ListCafeApplicationsResponseSchema =
    CafeApplications.CafeApplicationsListResponseSchema;
export type ListCafeApplicationsResponse = CafeApplications.CafeApplicationsListResponse;

/**
 * Ответ карточки `GET /cafe-applications/:id` — `{ application }`.
 */
export const GetCafeApplicationResponseSchema =
    CafeApplications.CafeApplicationDetailResponseSchema;
export type GetCafeApplicationResponse = CafeApplications.CafeApplicationDetailResponse;

export const ApproveCafeApplicationRequestSchema =
    CafeApplications.ApproveCafeApplicationRequestSchema;
export type ApproveCafeApplicationRequest = CafeApplications.ApproveCafeApplicationRequest;

export const ApproveCafeApplicationResponseSchema =
    CafeApplications.ApproveCafeApplicationResponseSchema;
export type ApproveCafeApplicationResponse = CafeApplications.ApproveCafeApplicationResponse;

export const RejectCafeApplicationRequestSchema =
    CafeApplications.RejectCafeApplicationRequestSchema;
export type RejectCafeApplicationRequest = CafeApplications.RejectCafeApplicationRequest;

export const RejectCafeApplicationResponseSchema =
    CafeApplications.RejectCafeApplicationResponseSchema;
export type RejectCafeApplicationResponse = CafeApplications.RejectCafeApplicationResponse;

/**
 * Фильтры списка заявок кафе для admin SPA. Соответствует
 * `CafeApplicationsListQuerySchema` (status default `pending` + search +
 * пагинация), но без `.strict()` — query собирается api-слоем.
 */
export const ListCafeApplicationsFiltersSchema = z.object({
    status: CafeApplications.CafeApplicationListItemSchema.shape.moderationStatus.optional(),
    search: z.string().optional(),
    limit: z.number().int().min(1).max(100).optional(),
    offset: z.number().int().min(0).optional()
});

export type ListCafeApplicationsFilters = z.infer<typeof ListCafeApplicationsFiltersSchema>;
